"use client";

import * as React from "react";
import { Quote, Star } from "lucide-react";
import { cn } from "@/lib/utils";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Eleanor & Julian",
  quote: "VOW transformed our vision into a breathtaking reality. The attention to detail in the ballroom was simply unparalleled.",
  position: "Married June 2023"
}, {
  author: "Sophia & Marcus",
  quote: "From the garden ceremony to the final dance, every moment felt curated just for us. A truly world-class experience.",
  position: "Married September 2023"
}];
export default function VoicesOfLove() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  React.useEffect(() => {
    if (!api) {
      return;
    }
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  return <section data-section-id="223764" id="voices-of-love" ref={ref} className={cn("dark bg-background py-24 sm:py-32 overflow-hidden transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="font-default text-3xl md:text-5xl font-medium tracking-tight text-foreground mb-4">
            Voices of Love
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-sans">
            Reflections from couples who began their forever within our estate's timeless walls.
          </p>
        </div>

        <div className="max-w-4xl mx-auto relative">
          <Carousel setApi={setApi} opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, index) => <CarouselItem key={index} data-index={index} className="md:basis-full lg:basis-full pl-4">
                  <div className="p-2 md:p-6">
                    <Card className="relative overflow-hidden rounded-md border-none shadow-xl bg-card h-full min-h-[320px] flex flex-col items-center justify-center p-8 md:p-12 text-center group">
                      {}
                      <Quote className="absolute top-6 left-6 md:top-10 md:left-10 size-32 md:size-48 text-primary/10 -rotate-12 transition-transform duration-700 group-hover:-rotate-6 group-hover:scale-110 pointer-events-none" />
                      
                      <CardContent className="relative z-10 flex flex-col items-center justify-center p-0 h-full w-full">
                        {}
                        <div className="flex gap-1.5 mb-8">
                          {[...Array(5)].map((_, starIndex) => <Star key={starIndex} data-index={starIndex} className="size-5 md:size-6 fill-primary text-primary drop-shadow-sm" />)}
                        </div>

                        {}
                        <p className="text-xl md:text-3xl font-default text-card-foreground mb-10 leading-relaxed max-w-2xl mx-auto italic">
                          "{testimonial.quote}"
                        </p>

                        {}
                        <div className="mt-auto">
                          <h4 className="font-mono font-medium text-sm md:text-base uppercase tracking-widest text-foreground">
                            {testimonial.author}
                          </h4>
                          <p className="text-muted-foreground font-sans text-xs md:text-sm mt-2">
                            {testimonial.position}
                          </p>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
          </Carousel>

          {}
          <div className="flex justify-center items-center gap-4 mt-8 h-12">
            {Array.from({
            length: count
          }).map((_, index) => <button key={index} data-index={index} onClick={() => api?.scrollTo(index)} aria-label={`Go to slide ${index + 1}`} className={cn("rounded-md transition-all duration-500 ease-out focus:outline-none focus-visible:ring-1 focus-visible:ring-ring", current === index ? "w-8 h-1 bg-primary shadow-sm" : "w-2 h-1 bg-primary/30 hover:bg-primary/50")} />)}
          </div>
        </div>
      </div>
    </section>;
}